import { render, staticRenderFns } from "./theme-pill.vue?vue&type=template&id=1362201a&"
import script from "./theme-pill.vue?vue&type=script&lang=js&"
export * from "./theme-pill.vue?vue&type=script&lang=js&"
import style0 from "./theme-pill.vue?vue&type=style&index=0&id=1362201a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports